// extracted by mini-css-extract-plugin
export default {"input-field":"InputNumber_input-field__T7itq","header-text":"InputNumber_header-text__0uh26"};